<template>
    <div class="pl-field" :class="{ 'pl-field--error': nameError }" data-field="name">
        <label for="pl-name">{{ nameLabel }} <span v-if="required" class="pl-required">*</span></label>
        <input
            id="pl-name"
            ref="nameInput"
            :value="name"
            class="pl-control"
            maxlength="150"
            @input="onNameInput"
            @blur="onNameBlur"
        >
        <p v-if="nameError" class="pl-field-error">{{ nameError }}</p>
    </div>
    <div class="pl-field" :class="{ 'pl-field--error': urlError }" data-field="url">
        <label for="pl-url">{{ urlLabel }} <span v-if="required" class="pl-required">*</span></label>
        <input
            id="pl-url"
            :value="url"
            class="pl-control pl-control--readonly"
            maxlength="200"
            readonly
            tabindex="-1"
            aria-readonly="true"
        >
        <p v-if="urlError" class="pl-field-error">{{ urlError }}</p>
        <p v-if="slugStatus === 'checking'" class="pl-slug-checking">Verifica…</p>
        <div v-else-if="slugStatus === 'available'" class="pl-slug-state">
            <span class="pl-badge pl-badge--success">Disponibile</span>
        </div>
        <div v-else-if="slugStatus === 'conflict'" class="pl-inline-warning">
            <span class="pl-badge pl-badge--warning">Già usato</span>
            <span>Lista «{{ slugResult?.name }}» (#{{ slugResult?.id }})</span>
            <a v-if="slugResult?.show_url" :href="slugResult.show_url" class="pl-button pl-button--link">Apri</a>
            <a v-if="slugResult?.edit_url" :href="slugResult.edit_url" class="pl-button pl-button--link">Modifica</a>
        </div>
    </div>
</template>

<script>
import { slugFromName } from '../slugFromName';

export default {
    name: 'NameSlugFields',
    props: {
        mode: { type: String, required: true },
        name: { type: String, default: '' },
        url: { type: String, default: '' },
        nameLabel: { type: String, default: 'Nome' },
        urlLabel: { type: String, default: 'Url' },
        required: { type: Boolean, default: true },
        nameError: { type: String, default: null },
        urlError: { type: String, default: null },
        slugStatus: { type: String, default: 'idle' },
        slugResult: { type: Object, default: null },
    },
    emits: ['update:name', 'update:url', 'check-slug', 'clear-error'],
    methods: {
        onNameInput(event) {
            const nextName = event.target.value;
            this.$emit('update:name', nextName);
            this.$emit('clear-error', 'name');
            if (this.mode === 'create') {
                this.$emit('update:url', slugFromName(nextName));
                this.$emit('clear-error', 'url');
            }
        },
        onNameBlur() {
            if (this.mode === 'create') {
                this.$emit('check-slug');
            }
        },
        focusName() {
            this.$refs.nameInput?.focus();
        },
    },
};
</script>
